import { useState, useEffect } from 'react'


function TodoItem( props ) {

    const [hovering, setHovering] = useState(false)
    const [dateText, setDateText] = useState('')

    useEffect(() => {
        if (props.data.dateDue) {
            const date = new Date(props.data.dateDue)
            const dateFormatted = (date.getMonth() + 1) + '/'
                                  + date.getDate() + '/'
                                  + date.getFullYear() + " "
                                  + ((date.getHours() % 12) || 12) + ":"
                                  + (date.getMinutes() > 9 ? '' : '0') + date.getMinutes()
                                  + (date.getHours() >= 12 ? 'PM' : 'AM')
            setDateText(dateFormatted)
        }
    })

    const hoverOver = isHovering => {
        setHovering(isHovering)
    }


    return (
        <div className={'todo-item ' + (hovering ? 'darken' : '')} onClick={() => {if (hovering) props.toggle(props.data._id)}}>
            <div className={'toggle toggle-' + (props.data.completed ? 'on' : 'off')} onClick={() => props.toggle(props.data._id)}></div>
            <div className='center ' onMouseEnter={() => hoverOver(true)} onMouseLeave={() => hoverOver(false)}>
                <label className='item-label'>{props.data.label}</label>
                {props.data.dateDue ? (<label className='due-date'>Due: {dateText}</label>) : ''}
                {props.data.tag ? <label className='tag'>{props.data.tag}</label> : ''}

            </div>
            <div className='dark-hover right-btn' onClick={() => props.editBtn(props.data)}>...</div>
            <div className='dark-hover right-btn' onClick={() => props.deleteBtn(props.data)}>x</div>
        </div>
    )
}

export default TodoItem;